import userApi from 'api/requests/user'
import Button from 'components/_UI/Button'
import Fieldset from 'components/_UI/Fieldset'
import Loader from 'components/_UI/Loader'
import Text from 'components/_UI/Text'
import fieldValidations from 'helpers/fieldValidations'
import masks from 'helpers/masks'
import React, { useState } from 'react'
import { ArrowDownLeft, ArrowLeft, ChevronLeft } from 'react-feather'
import { useForm } from 'react-hook-form'
import styled from 'styled-components'
import { StyledForm } from 'styled/UI/StyledForm'
import { FullyCentered, HorizontalCenter } from 'styled/alignment/Center'
import { Column } from 'styled/alignment/Column'
import fieldMessages from 'texts/messages/field'
import colors from 'theme/colors'
export default function PartnerFormStepOne({ onNextClick = () => { } }) {
  const savedData = JSON.parse(sessionStorage.getItem('partnerSignUpStepOne') || '{}');
  const defaultFirstName = savedData.firstName || (savedData.full_name ? savedData.full_name.split(' ')[0] : '');
  const defaultLastName = savedData.lastName || (savedData.full_name ? savedData.full_name.split(' ').slice(1).join(' ') : '');

  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
    watch,
    resetField
  } = useForm({
    defaultValues: {
      firstName: defaultFirstName,
      lastName: defaultLastName,
      email: savedData.email || '',
      phone: savedData.phone || '',
      birth_date: savedData.birth_date || '',
      document: savedData.document || ''
    }
  });

  // const [content, setContent] = useState();
  const [loading, setLoading] = useState(false);
  const [mailError, setMailError] = useState(false);


  async function validateData({ firstName, lastName, email, phone, document, birth_date }) {
    let isValid = false;

    try {
      setLoading(true);

      const { data } = await userApi.dataEnable({ email });
      isValid = data?.email;

    } catch (error) {

    } finally {
      setLoading(false)
    }

    if (!isValid) {
      setMailError('O e-mail utilizado já está cadastrado na plataforma. Por favor, utilize outro e-mail.');
      return
    }


    const content = {
      full_name: `${firstName} ${lastName}`,
      firstName,
      lastName,
      email,
      phone,
      birth_date,
      document
    }

    sessionStorage.setItem('partnerSignUpStepOne', JSON.stringify(content));

    setMailError(false);
    onNextClick();
  }

  const emailAvailable = async (email) => {

    let isValid = false;
    try {
      setLoading(true);

      const { data } = await userApi.dataEnable({ email });
      isValid = data?.email;

    } catch (error) {

    } finally {
      setLoading(false)
      return isValid;
    }

  }

  return (
    <FormContainer>
      <Text name={'highlight'} color={colors.nightDark} textAlign={'center'}>
        Para começar, conte pra gente quem será o responsável pela conta.
      </Text>

      <StyledForm onSubmit={handleSubmit(validateData)}>

        <Fieldset
          layout='squired'
          placeholder='Seu nome'
          label='Nome'
          name="firstName"
          register={register}
          validations={fieldValidations.name('Nome')}
        />
        <HorizontalCenter>
          <Text color={colors.danger}> {errors.firstName?.message} </Text>
        </HorizontalCenter>

        <Fieldset
          layout='squired'
          placeholder='Seu sobrenome'
          label='Sobrenome'
          name="lastName"
          register={register}
          validations={fieldValidations.name('Sobrenome')}
        />
        <HorizontalCenter>
          <Text color={colors.danger}> {errors.lastName?.message} </Text>
        </HorizontalCenter>

        <Fieldset
          layout='squired'
          placeholder='seu_email@exemplo.com'
          label='E-mail'
          name="email"
          register={register}
          validations={fieldValidations.email('E-mail')}
        />
        <HorizontalCenter>
          <Text color={colors.danger}> {errors.email?.message} </Text>
        </HorizontalCenter>
        {mailError && (
          <HorizontalCenter>
            <Text color={colors.danger} textAlign={'center'}> {mailError} </Text>
          </HorizontalCenter>
        )}

        <Fieldset
          layout='squired'
          placeholder='00/00/0000'
          label='Data de nascimento'
          mask={masks.date}
          name="birth_date"
          register={register}
          validations={fieldValidations.date('Data de nascimento')}
        />
        <HorizontalCenter>
          <Text color={colors.danger}> {errors.birth_date?.message} </Text>
        </HorizontalCenter>

        <Fieldset
          layout='squired'
          placeholder='(00) 00000-0000'
          label='Telefone'
          mask={masks.phone}
          name="phone"
          register={register}
          validations={fieldValidations.phone('Telefone')}
        />
        <HorizontalCenter>
          <Text color={colors.danger}> {errors.phone?.message} </Text>
        </HorizontalCenter>

        <Fieldset
          layout='squired'
          placeholder='000.000.000-00'
          label='CPF'
          mask={masks.cpf}
          name="document"
          register={register}
          validations={fieldValidations.cpf('CPF')}
        />
        <HorizontalCenter>
          <Text color={colors.danger}> {errors.document?.message} </Text>
        </HorizontalCenter>

        {loading
          ? (
            <FullyCentered>
              <Loader />
            </FullyCentered>
          ) : (
            <Column marginTop='20px'>
              <Button
                category={'squiredBorded'}
                variant={'featured'}
                type='submit'
              >
                Avançar
              </Button>
            </Column>
          )

        }
      </StyledForm>
    </FormContainer>
  )
}

const FormContainer = styled(Column)`
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 30px;
`
